<template>
  <div class="navigation-side-bar-title">{{ title }}</div>
</template>

<script setup lang="ts">
type Props = {
  title: string;
};

defineProps<Props>();
</script>

<style lang="scss" scoped>
.navigation-side-bar-title {
  color: #737d90;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  font-size: 0.75rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
}
</style>
